import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { ValueProps } from '../components/ValueProps';
import { FamilyCaregiverSection } from '../components/FamilyCaregiverSection';
import { TestimonialsSection } from '../components/TestimonialsSection';
import { CTABanner } from '../components/CTABanner';
export function HomePage() {
  return <main data-id="element-355">
      <HeroSection data-id="element-356" />
      <ValueProps data-id="element-357" />
      <FamilyCaregiverSection data-id="element-358" />
      <TestimonialsSection data-id="element-359" />
      <CTABanner data-id="element-360" />
    </main>;
}